var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "learning__config-edit_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1691",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "learning__config-edit_pgroup1",
    "data-name": "Group 1690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "learning__config-edit_path",
    "data-name": "Path 6",
    d: "M19.13,2.266a.858.858,0,0,1,1.243,0h0L25.7,7.593a.858.858,0,0,1,0,1.243h0L10.607,23.927a1.94,1.94,0,0,1-.444.266h0l-7.1,1.775A.881.881,0,0,1,2,24.9H2l1.775-7.1c0-.178.089-.266.266-.444h0ZM16.2,7.682,5.458,18.423,4.127,23.839l5.415-1.332L20.284,11.765Zm3.551-3.551L17.443,6.439l4.084,4.084,2.308-2.308Z",
    transform: "translate(-1.965 -2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.b701fd73.svg";
export { ForwardRef as ReactComponent };